import { render } from "./FlightSlider.vue?vue&type=template&id=10b6f192"
import script from "./FlightSlider.vue?vue&type=script&lang=js"
export * from "./FlightSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__